import React from "react"
import { useSiteMetadata } from "@tmu/hooks"
import SEO from "@tmu/components/seo"

export default function cb() {
  const { title, description } = useSiteMetadata()

  return <SEO title={title} description={description} />
}
